export default __webpack_public_path__ + "static/media/re3.31e825fd.jpg";